/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Chip from '@mui/material/Chip';
import useTeamDashboardContext from '../context/useTeamDashboardContext';

function Table() {
  //
  const { tableData, selectedDate, handleResetTable } = useContext(useTeamDashboardContext);

  const [sortModel, setSortModel] = useState([
    {
      field: 'appointment_date',
      sort: 'asc',
    },
  ]);

  const columns = [
    { field: 'rsm_name', flex: 1, headerName: 'RSM Name', width: 200 },
    { field: 'dm_name', flex: 1, headerName: 'DM Name', width: 200 },
    { field: 'mpr_name', flex: 1, headerName: 'MPR Name', width: 200 },
    { field: 'md_name', flex: 1, headerName: 'MD Name', width: 200 },
    { field: 'scheduled_clinic', flex: 1, headerName: 'Scheduled Clinic', width: 200 },
    { field: 'actual_clinic', flex: 1, headerName: 'Actual Clinic', width: 200 },
    { field: 'appointment_date', flex: 1, headerName: 'Appointment Date', width: 200 },
    { field: 'appointment_time', flex: 1, headerName: 'Appointment Time', width: 200 },
    { field: 'submitted_date', flex: 1, headerName: 'Submitted Date', width: 200 },
    { field: 'approved_date', flex: 1, headerName: 'Approved Date', width: 200 },
    { field: 'completed_date', flex: 1, headerName: 'Completed Date', width: 200 },
    { field: 'status', flex: 1, headerName: 'Status', width: 200 },
  ];
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        {selectedDate ? (
          <Chip
            label={selectedDate}
            variant='outlined'
            onDelete={handleResetTable}
            sx={{ fontSize: '20px', width: '250px' }}
          />
        ) : (
          ''
        )}
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px' }}>
          <DataGridPro
            rows={tableData.data}
            columns={columns}
            loading={tableData.loading}
            sortModel={sortModel}
            initialState={{
              ...tableData.data.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
